import React from 'react';

function Tester () {
  return (
    <div className="home-page"> Hello
      {/* Section to display user's links */}
      <div className="links-section">
        {/* Display user's links here */}
      </div>

      {/* Section to display user's social media profiles */}
      <div className="social-media-section">
        {/* Display user's social media profiles here */}
      </div>

      {/* Section to display QR code */}
      
    </div>
  );
}
export default Tester;